export default __webpack_public_path__ + "static/media/Osthammar_full.eb00d58a.svg";